import { PromptType } from '@communities/prompt-management/domain';

import * as styles from './PromptTypeTabs.css';

export interface PromptTypeTabsProps {
  activeTab: PromptType;
  onTabChange: (tab: PromptType) => void;
}

/**
 * PromptTypeTabs Component
 *
 * Displays tabs for switching between Classification and Moderation prompt views
 */
export function PromptTypeTabs({ activeTab, onTabChange }: PromptTypeTabsProps) {
  return (
    <div className={styles.tabContainer}>
      <button
        className={activeTab === PromptType.CLASSIFICATION ? styles.activeTab : styles.tab}
        type="button"
        onClick={() => onTabChange(PromptType.CLASSIFICATION)}
      >
        CLASSIFICATION
      </button>
      <button className={activeTab === PromptType.MODERATION ? styles.activeTab : styles.tab} type="button" onClick={() => onTabChange(PromptType.MODERATION)}>
        MODERATION
      </button>
    </div>
  );
}
